import { useState, useEffect } from 'react';

import { countRead } from '../../firestoreReadCounter';

export default function useDocumentSubscription (ref, dependencies = []) {
  const [item, setItem] = useState();
  useEffect(() => {
    if(!ref) return setItem(undefined);

    const unsubscribe = ref
      .onSnapshot((doc) => {
        if(doc.exists) {
          setItem({ id: doc.id, ref, ...doc.data() });
        } else {
          setItem(null);
        }
      });
    return unsubscribe;
  }, dependencies);
  return item;
};
